var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.957031H513V342.961H0V0.957031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 112.479H513V231.439H0V112.479Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 268.61H513V342.962H0V268.61ZM0 0.957031H513V75.309H0V0.957031Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.244 133.888L266.692 162.966H297.27L272.532 180.94L281.981 210.02L257.244 192.048L232.507 210.02L241.956 180.94L217.218 162.966H247.795L257.244 133.888Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/SR.53e89f6b0ab82a476b017980015697fa.svg";
export { ForwardRef as ReactComponent };